import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=0762f475&"
import script from "./Role.vue?vue&type=script&lang=js&"
export * from "./Role.vue?vue&type=script&lang=js&"
import style0 from "./Role.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports